var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaaAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17743_6692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5V62.5C0 72.1625 7.8375 80 17.5 80H62.5C72.1625 80 80 72.1625 80 62.5V17.5C80 7.8375 72.1625 0 62.5 0H17.5C7.8375 0 0 7.8375 0 17.5Z",
    fill: "url(#paint0_linear_17743_6692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1062 22.7123C69.225 19.6373 59.4437 21.5748 47.25 26.9685C43.2 24.181 37.2812 22.4185 30.6875 22.4185C18.475 22.4185 8.56873 28.4498 8.56873 35.8935C8.56873 40.381 12.175 44.356 17.7125 46.806C12.575 51.381 9.97498 55.281 11.1937 57.3185C11.2937 57.4935 11.425 57.6435 11.5812 57.7873L33.5875 79.9935H62.5C72.1625 79.9935 80 72.156 80 62.4935V37.5998L71.1125 22.7185L71.1062 22.7123Z",
    fill: "#0F66B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25 26.9689C43.2 24.1814 37.2812 22.4189 30.6875 22.4189C18.475 22.4189 8.56873 28.4502 8.56873 35.8939C8.56873 40.3814 12.175 44.3564 17.7125 46.8064C12.575 51.3814 9.97498 55.2814 11.1937 57.3189C12.625 59.7189 19 58.9877 27.55 55.9002L27.45 55.7627C20.6125 58.0627 15.6 58.5064 14.4125 56.5252C13.3687 54.7814 15.5 51.4877 19.7687 47.6064C22.9875 48.7252 26.7125 49.3627 30.6812 49.3627C42.8937 49.3627 52.8 43.3314 52.8 35.8876C52.8 33.1439 51.45 30.5877 49.1312 28.4564C58.425 24.7127 65.5937 23.5689 67.0687 26.0377C68.8312 28.9939 61.8937 36.1877 50.8562 43.3752L50.9812 43.5064C64.5062 34.9877 73.2 26.2252 71.1125 22.7252C69.2625 19.6189 59.4625 21.5564 47.2437 26.9627L47.25 26.9689ZM42.5562 39.4502H37.9562L40.225 31.2252L42.55 39.4502H42.5562ZM29.7187 23.6001L25.2875 39.4502H25.2625L21.1062 25.4127C23.6312 24.3627 26.5687 23.7127 29.7125 23.6064L29.7187 23.6001ZM31.8125 39.4502H27.2L29.4812 31.2252L31.8125 39.4502ZM21.0312 39.4502H16.4625L18.7437 31.2252L21.0312 39.4502ZM12.4125 35.8939C12.4125 32.4127 14.5625 29.2689 18.0125 27.0314L14.0937 41.0564C13.0187 39.4877 12.4125 37.7439 12.4125 35.9002V35.8939ZM23.1437 47.1064C20.05 46.1627 17.4187 44.6564 15.5375 42.7752L16.0062 41.0939H21.4937L23.1562 47.0752V47.1064H23.1437ZM30.6812 48.2064C28.675 48.2064 26.7437 47.9877 24.9312 47.5814L26.7312 41.0939H32.2687L34.2125 47.9689C33.0687 48.1189 31.8875 48.2002 30.675 48.2002L30.6812 48.2064ZM36.0125 39.4502L31.3125 23.5939C34.475 23.6689 37.425 24.2752 39.9812 25.2939L36.0312 39.4439H36.0125V39.4502ZM38.2812 47.0939L37.0187 42.8377L37.5 41.0939H43.0187L43.9437 44.3627C42.3437 45.5002 40.425 46.4314 38.2812 47.0939ZM47.25 41.1064L43.0062 26.8064C46.6625 29.0564 48.9625 32.3001 48.9625 35.9002C48.9625 37.7627 48.3437 39.5251 47.25 41.1064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17743_6692",
    x1: 40,
    y1: 80,
    x2: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F66B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0F68B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0197FB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17743_6692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaaAppLogo);
export default __webpack_public_path__ + "static/media/aaa-app-logo.0eeff2ae7361c45ae3a7486177746190.svg";
export { ForwardRef as ReactComponent };